import React, { useState, useEffect, useMemo, memo, useCallback } from "react";
import { Spinner, Button } from "reactstrap";
import Accordion from "../../../../Common/Accordion";

import "./SummariesContent.scss";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import SummaryContent from "../../../../Common/Summary/summaryContent";

import {
  generateSummary,
  getSummaries,
  resetError,
} from "../../../../../store/summarization/actions";

const SummariesContent = ({ chatId,hasObserver, t }) => {
  const dispatch = useDispatch();

  const { dataSummaries, generate_summary } = useSelector(
    (state) => state.Summarization
  );
  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => {},
  };

  useEffect(() => {
    if (generate_summary.error && generate_summary.messageError) {
     showToast("error", t(generate_summary.messageError));
     dispatch(resetError());
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generate_summary.error]);
  const [collapse, setCollapse] = useState([]);
  const toggle = useCallback(
    (key) => {
      let aux = [...collapse];
      aux[key] = !aux[key];
      setCollapse(aux);
    },
    [collapse]
  );
  const summarizeConversation = useCallback(() => {
    dispatch(generateSummary({ conversationId: chatId, messageId: null}));
  }, [dispatch, chatId]);

  const renderSummaries = useMemo(() => {
    if (chatId && dataSummaries?.summaryResult.length > 0) {
      return dataSummaries?.summaryResult.map((item, key) => {
        return (
          <Accordion
            key={item.id}
            title={item?.created_at}
            isOpen={collapse[key]}
            value={key}
            toggle={() => toggle(key)}
            style={{ padding: "4px 0 4px 0" }}
          >
            <SummaryContent
              userName={item?.created_by_user_name}
              keywords={item?.keywords}
              summary={item?.summary}
            />
          </Accordion>
        );
      });
    } else {
      return;
    }
  }, [dataSummaries, collapse, toggle, chatId]);

  const renderButton = useMemo(() => {
    if (generate_summary.loading) {
      return (
        <>
        <hr className="dropdown-divider mb-0" />
        <Button
          color="primary"
          className="mt-3"
          disabled={true} 
        >
          {t("Summarize conversation")}
        </Button>
      </>
      );
    } else if (chatId) {
      return (
        <>
          <hr className="dropdown-divider mb-0" />
          <Button
            color="primary"
            className="mt-3"
            onClick={summarizeConversation}
          >
            {t("Summarize conversation")}
          </Button>
        </>
      );
    } else {
      return;
    }
  }, [chatId, generate_summary.loading, summarizeConversation, t]);

  useEffect(() => {
    chatId && dispatch(getSummaries(chatId));
  }, [chatId, dispatch]);

  return (
    <div className="client-info-card">
      <div className="summary-text-title">
        {t(
          "A feature that allows you to summarize this conversation quickly and easily, increasing your productivity"
        )}
      </div>

      {generate_summary.loadingGetSummaries ||  generate_summary.loading ? (
        <div className="loading-container">
          <Spinner
            color="primary"
            style={{ width: "3rem", height: "3rem" }}
            className="spinner"
          />
          <div>{t("Reading in progress...")}</div>
        </div>
      ) : (
        <div>
          {renderSummaries}
          {renderButton} 
        </div>
      )}
    </div>
  );
};
export default withTranslation()(memo(SummariesContent));
